import React, { useState, useCallback, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-timezone'
import { setNewAddressMailingAddressSame, changeObjectPropertyAction } from 'redux/actions';

import NewMailingAddress from './NewMailingAddress';

import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from 'shared/components/BackAnchor'

import StreetAddress from 'shared/components/Address/StreetAddress'
import Apartment from 'shared/components/Address/Apartment'
import City from 'shared/components/Address/City'
import PostalCode from 'shared/components/Address/PostalCode'
import AddressAutofill from '../../../../shared/components/Address/AddressAutofill'

// import styles from './NewAddress.module.scss'
import { validateApartmentErrors, validateCityErrors, validatePostalCodeErrors, validateStreetAddressErrors } from '../../../../shared/helpers/validators'

const NEW_ADDRESS = 'newAddress';

const initialAddress = {
  city: '',
  streetAddress: '',
  apartment: '',
  postalCode: ''
};

const NewAddressView = ({ t, i18n, setIsError }) => {
  const history = useHistory()

  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [streetAddressValid, setStreetAddressValid] = useState('')
  const [apartmentValid, setApartmentValid] = useState('')
  const [cityValid, setCityValid] = useState('')
  const [postalCodeValid, setPostalCodeValid] = useState('')

  const [streetAddressError, setStreetAddressError] = useState('current_address.street_address_error')
  const [apartmentError] = useState('current_address.apartment_error_invalid')
  const [cityError, setCityError] = useState('current_address.city_error')
  const [postalCodeError, setPostalCodeError] = useState('current_address.postal_code_error')

  const { city, streetAddress, apartment, postalCode, mailingAddress } = useSelector((state) => state.app.newAddress)
  const mailingAddressSame = useSelector((state) => state.app.newAddress.mailingAddressSame);

  const homeAddressToChange = useSelector((state) => state.app.addressesToChange.homeAddress);
  const mailingAddressToChange = useSelector((state) => state.app.addressesToChange.mailingAddress);
  const [mailingAddressErrors, setMailingAddressErrors] = useState({ ...initialAddress });
  const dispatch = useDispatch();

  // const continueCancelProps = {
  //   prevText: t('current_address.back'),
  //   prevURL: `/${i18n.language}${t('routes.listed_permits')}`,
  //   nextText: t('current_address.next'),
  // }

  // useEffect(() => {
  //   try {
  //     if (!nsHealthCard && !driverLicence && !vehiclePermit && !registeredByName) {
  //       history.push(`/${i18n.language}${t('routes.address_type_change')}`)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }, [])

  const isSummary = useMemo(() => {
    return JSON.parse(new URLSearchParams(history.location.search).get("isSummary") ?? false);
  }, [history]);

  const onNext = () => {
    try {
      if (validateFields()) {
        if (isSummary) {
          history.push(`/${i18n.language}${t('routes.review_summary')}`)
        } else {
          history.push(`/${i18n.language}${t('routes.contact_info')}`)
        }

      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      let homeAddressValuesValid = true;
      let mailingAddressValuesValid = true;
      if (homeAddressToChange) {
        validateStreetAddress(streetAddress)
        validateApartment(apartment)
        validateCity(city)
        validatePostalCode(postalCode)
        if (streetAddress === '') {
          setStreetAddressValid(false)
        }
        if (city === '') {
          setCityValid(false)
        }
        if (postalCode === '') {
          setPostalCodeValid(false)
        }

        homeAddressValuesValid = (
          streetAddressValid === true &&
          (apartmentValid === '' || apartmentValid === true) &&
          cityValid === true &&
          postalCodeValid === true &&
          streetAddress !== '' &&
          city !== '' &&
          postalCode !== ''
        )
      }

      //Mailing Address
      const mailingAddressDifferentFromHome = (homeAddressToChange && !mailingAddressSame)
      if (mailingAddressToChange && mailingAddressDifferentFromHome) {
        mailingAddressErrors.streetAddress = validateStreetAddressErrors(mailingAddress.streetAddress)
        mailingAddressErrors.apartment = validateApartmentErrors(mailingAddress.apartment);
        mailingAddressErrors.city = validateCityErrors(mailingAddress.city);
        mailingAddressErrors.postalCode = validatePostalCodeErrors(mailingAddress.postalCode);

        if (mailingAddressErrors.streetAddress === '') {
          mailingAddressErrors.streetAddress = 'current_address.street_address_error';
        }
        // if (mailingAddressErrors.apartment === '') {
        //   mailingAddressErrors.apartment = 'current_address.apartment_error_invalid';
        // }
        if (mailingAddressErrors.postalCode === '') {
          mailingAddressErrors.postalCode = 'current_address.postal_code_error';
        }
        if (mailingAddressErrors.city === '') {
          mailingAddressErrors.city = 'current_address.city_error_invalid';
        }

        setMailingAddressErrors({ ...mailingAddressErrors });

        mailingAddressValuesValid = (
          !mailingAddressErrors.streetAddress &&
          (mailingAddressErrors.apartment === '' || !mailingAddressErrors.apartment) &&
          !mailingAddressErrors.cityValid &&
          !mailingAddressErrors.postalCode &&
          mailingAddress.streetAddress !== '' &&
          // apartment !== '' &&
          mailingAddress.city !== '' &&
          mailingAddress.postalCode !== ''
        )
      }

      return homeAddressValuesValid && mailingAddressValuesValid;
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateStreetAddress = (name) => {
    try {
      const regex = RegExp(/^.*$/);
      if (name.length > 0) {
        if (regex.test(name)) {
          setStreetAddressValid(true)
        } else {
          setStreetAddressValid(false)
          setStreetAddressError('current_address.street_address_error')
        }
      } else {
        setStreetAddressValid(false)
        setStreetAddressError('current_address.street_address_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateApartment = (name) => {
    setApartmentValid(true)
    return;
    // try {
    //   const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
    //   if (name.length > 0) {
    //     if (regex.test(name)) {
    //       setApartmentValid(true)
    //     } else {
    //       setApartmentValid(false)
    //       setApartmentError('current_address.apartment_error_invalid')
    //     }
    //   } else {
    //     setApartmentValid('')
    //     // setApartmentError('current_address.apartment_error')
    //   }
    // } catch (e) {
    //   console.log(e)
    //   setIsError(true)
    // }
  }


  const validateCity = (cityName) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (cityName.length > 0) {
        if (regex.test(cityName)) {
          setCityValid(true)
        } else {
          setCityValid(false)
          setCityError('current_address.city_error')
        }
      } else {
        setCityValid(false)
        setCityError('current_address.city_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }


  const validatePostalCode = (number) => {
    try {
      const regex = RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i)
      if (regex.test(number)) {
        setPostalCodeValid(true)
      } else {
        setPostalCodeValid(false)
        setPostalCodeError('current_address.ns_postal_code_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const handleRadio = (e) => {
    let field = e.currentTarget.value;
    dispatch(setNewAddressMailingAddressSame(field === "sameAsHomeAddress"));
  }

  const handleChangeObjectPropertyAction = useCallback((fieldName, value) => {
    dispatch(changeObjectPropertyAction('newAddress', fieldName, value))
  }, [dispatch]);

  const { nsHealthCard, driverLicence, registeredByName, jointlyRegistered, registeredBusiness } = useSelector((state) => state.app.addressTypeChange)
  const isCivic = useMemo(() => {
    return !(nsHealthCard || driverLicence || registeredByName || jointlyRegistered) && registeredBusiness
  }, [driverLicence, nsHealthCard, registeredByName, jointlyRegistered, registeredBusiness]);

  const getTitle = () => {
    if (mailingAddressToChange && homeAddressToChange) {
      return isCivic ? t('new_address.tell_us_new_address_business') : t('new_address.tell_us_new_address');
    } else if (homeAddressToChange) {
      return isCivic ? t('new_address.tell_us_new_civic_address') : t('new_address.tell_us_new_home_address');

    } else {
      return t('new_address.tell_us_new_mailing_address');
    }
  }

  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12">
              <h1>{getTitle()}</h1>
            </div>
          </div>
          {homeAddressToChange && (
            <>
              <div className="row">
                <div className="col-xs-12">
                  <h2>{isCivic ? t('new_address.civic_address') : t('new_address.home_address')}</h2>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <AddressAutofill
                    validateStreetAddress={validateStreetAddress}
                    streetAddressError={streetAddressError}
                    streetAddressValid={streetAddressValid}
                    setIsError={setIsError}
                    reduxAppProperty={NEW_ADDRESS}
                    changeObjectPropertyAction={handleChangeObjectPropertyAction}
                    validateCity={validateCity}
                    validatePostalCode={validatePostalCode}
                    cityError={cityError}
                    cityValid={cityValid}
                    postalCodeError={postalCodeError}
                    postalCodeValid={postalCodeValid}
                    validateApartment={validateApartment}
                    apartmentError={apartmentError}
                    apartmentValid={apartmentValid}
                  />
                  {/* <AddressAutofill
                    validateStreetAddress={validateStreetAddress}
                    streetAddressError={streetAddressError}
                    streetAddressValid={streetAddressValid}
                    setIsError={setIsError}
                    reduxAppProperty={NEW_ADDRESS}
                    changeObjectPropertyAction={handleChangeObjectPropertyAction}
                    validateCity={validateCity}
                    validatePostalCode={validatePostalCode}
                    cityError={cityError}
                    cityValid={cityValid}
                    postalCodeError={postalCodeError}
                    postalCodeValid={postalCodeValid}

                  /> */}
                  {/* <StreetAddress
                    validateStreetAddress={validateStreetAddress}
                    streetAddressError={streetAddressError}
                    streetAddressValid={streetAddressValid}
                    setIsError={setIsError}
                    reduxAppProperty={NEW_ADDRESS}
                    changeObjectPropertyAction={handleChangeObjectPropertyAction}
                  />
                  <Apartment
                    validateApartment={validateApartment}
                    apartmentError={apartmentError}
                    apartmentValid={apartmentValid}
                    setIsError={setIsError}
                    reduxAppProperty={NEW_ADDRESS}
                    changeObjectPropertyAction={handleChangeObjectPropertyAction}
                  />
                  <City
                    validateCity={validateCity}
                    validatePostalCode={validatePostalCode}
                    cityError={cityError}
                    cityValid={cityValid}
                    setIsError={setIsError}
                    reduxAppProperty={NEW_ADDRESS}
                    changeObjectPropertyAction={handleChangeObjectPropertyAction}
                  />
                  <PostalCode
                    validatePostalCode={validatePostalCode}
                    postalCodeError={postalCodeError}
                    postalCodeValid={postalCodeValid}
                    setIsError={setIsError}
                    reduxAppProperty={NEW_ADDRESS}
                    changeObjectPropertyAction={handleChangeObjectPropertyAction}
                  /> */}
                </div>
              </div>
              {mailingAddressToChange && (
                <>
                  <div className="row">
                    <div className="col-xs-12">
                      <h2>{t('new_address.mailing_address')}</h2>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12">
                      <div className='ns-radios__item'>
                        <input className="ns-radios__input" type="radio" id={t('new_address.same_as_home_address')} value="sameAsHomeAddress" onChange={handleRadio}
                          checked={mailingAddressSame} />
                        <label className="ns-label ns-radios__label" htmlFor={t('new_address.same_as_home_address')} key={t('new_address.same_as_home_address')}>
                          <span className="ns-label-span">{isCivic ? t('new_address.same_as_civic_address') : t('new_address.same_as_home_address')}</span>
                        </label>
                      </div>
                      <div className='ns-radios__item'>
                        <input className="ns-radios__input" type="radio" id={t('new_address.different_than_home_address')} value="differentThanHomeAddress" onChange={handleRadio}
                          checked={!mailingAddressSame} />
                        <label className="ns-label ns-radios__label" htmlFor={t('new_address.different_than_home_address')} key={t('new_address.different_than_home_address')}>
                          <span className="ns-label-span">{isCivic ? t('new_address.different_than_civic_address') : t('new_address.different_than_home_address')}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  {!mailingAddressSame && (
                    <NewMailingAddress
                      mailingAddressErrors={mailingAddressErrors}
                      setMailingAddressErrors={setMailingAddressErrors}
                    />
                  )}
                </>
              )}

            </>
          )}


          {!homeAddressToChange && mailingAddressToChange && (
            <NewMailingAddress
              mailingAddressErrors={mailingAddressErrors}
              setMailingAddressErrors={setMailingAddressErrors}
            />
          )}

          <ContinueCancelButtons continueClick={onNext} errorText={''} />
        </article>
      </main>
    </div >
  )
}

export default withTranslation('common')(NewAddressView)
